import { NewsItem, DashboardStats } from '../types';

// Mock data para notícias
const mockNewsItems: NewsItem[] = [
  {
    id: '1',
    title: 'Petrobras anuncia novo plano de investimentos em energia renovável',
    summary: 'A empresa planeja investir R$ 15 bilhões em projetos de energia solar e eólica nos próximos 3 anos, fortalecendo sua posição no mercado de energia limpa.',
    impact: 'positive',
    company: 'Petrobras',
    time: '2 horas atrás',
    isRead: false
  },
  {
    id: '2',
    title: 'Vale reporta queda de 8% na produção de minério de ferro',
    summary: 'A redução na produção foi causada por problemas operacionais em uma das principais minas. A empresa espera normalizar a produção até o final do trimestre.',
    impact: 'negative',
    company: 'Vale',
    time: '4 horas atrás',
    isRead: false
  },
  {
    id: '3',
    title: 'Ambev lança nova linha de cervejas premium no mercado brasileiro',
    summary: 'A empresa expande seu portfólio com foco no segmento premium, esperando aumentar a margem de lucro em 12% no próximo ano.',
    impact: 'positive',
    company: 'Ambev',
    time: '6 horas atrás',
    isRead: true
  },
  {
    id: '4',
    title: 'Itaú Unibanco mantém taxa de juros estável para empréstimos',
    summary: 'O banco decidiu manter as taxas de juros inalteradas, refletindo a estabilidade do cenário econômico atual.',
    impact: 'neutral',
    company: 'Itaú',
    time: '8 horas atrás',
    isRead: true
  },
  {
    id: '5',
    title: 'Magazine Luiza anuncia expansão para 50 novas cidades',
    summary: 'A varejista planeja abrir lojas físicas e centros de distribuição em cidades do interior, aumentando sua presença nacional.',
    impact: 'positive',
    company: 'Magazine Luiza',
    time: '10 horas atrás',
    isRead: false
  },
  {
    id: '6',
    title: 'Bradesco enfrenta desafios com aumento de inadimplência',
    summary: 'O banco registrou aumento de 2.3% na inadimplência no último trimestre, impactando os resultados financeiros.',
    impact: 'negative',
    company: 'Bradesco',
    time: '12 horas atrás',
    isRead: true
  }
];

export const newsService = {
  // Buscar todas as notícias
  getAllNews: async (): Promise<NewsItem[]> => {
    // Simular delay de API
    await new Promise(resolve => setTimeout(resolve, 500));
    return [...mockNewsItems];
  },

  // Buscar notícias por empresa
  getNewsByCompany: async (companyId: string): Promise<NewsItem[]> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return mockNewsItems.filter(news => 
      news.company.toLowerCase().includes(companyId.toLowerCase())
    );
  },

  // Buscar notícias não lidas
  getUnreadNews: async (): Promise<NewsItem[]> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockNewsItems.filter(news => !news.isRead);
  },

  // Marcar notícia como lida
  markAsRead: async (newsId: string): Promise<boolean> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    const newsIndex = mockNewsItems.findIndex(news => news.id === newsId);
    if (newsIndex !== -1) {
      mockNewsItems[newsIndex].isRead = true;
      return true;
    }
    return false;
  },

  // Buscar estatísticas do dashboard
  getDashboardStats: async (): Promise<DashboardStats> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    const totalNews = mockNewsItems.length;
    const positiveNews = mockNewsItems.filter(news => news.impact === 'positive').length;
    const negativeNews = mockNewsItems.filter(news => news.impact === 'negative').length;
    const neutralNews = mockNewsItems.filter(news => news.impact === 'neutral').length;
    const unreadCount = mockNewsItems.filter(news => !news.isRead).length;

    return {
      totalNews,
      positiveNews,
      negativeNews,
      neutralNews,
      unreadCount
    };
  },

  // Buscar notícias por impacto
  getNewsByImpact: async (impact: 'positive' | 'negative' | 'neutral'): Promise<NewsItem[]> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockNewsItems.filter(news => news.impact === impact);
  }
};

